<template>
  <div class="flex flex-col">
    <label
      v-if="label"
      :for="id"
      class="mb-2 text-sm font-medium text-gray-900 dark:text-white"
    >{{ label }}</label>
    <input
      :id="id"
      :placeholder="placeholder"
      :required="required"
      :type="type"
      :value="modelValue"
      class="bg-white border-[0.2px] border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5"
      @input="handleInput"
    >
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'TextInput',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    handleInput(event: Event) {
      const target = event.target as HTMLInputElement;
      this.$emit('update:modelValue', target.value);
    }
  }
});
</script>
